import { useCallback, useEffect, useMemo, useState } from 'react';

const normalizePayload = (values = {}) => {
  const nombre = (values.nombre || '').trim();
  const bohRaw = values.boh;
  const bohNumber = bohRaw === '' || bohRaw === null || bohRaw === undefined ? null : Number(bohRaw);
  const boh = Number.isFinite(bohNumber) ? bohNumber : null;
  return {
    nombre,
    boh,
    activo: Boolean(values.activo)
  };
};

const validateBoh = (value) => Number.isInteger(value);

export const useAdminDivisions = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const fetchList = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/admin/api/divisions', { signal });
      const data = await response.json();
      if (!response.ok || data?.error) {
        throw new Error(data?.error || 'No se pudieron obtener las divisiones');
      }
      if (!signal?.aborted) {
        setItems(data.divisions || []);
      }
    } catch (err) {
      if (!signal?.aborted) {
        setError(err?.message || 'Error al cargar divisiones');
      }
    } finally {
      if (!signal?.aborted) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchList(controller.signal);
    return () => controller.abort();
  }, [fetchList, refreshToken]);

  const refresh = useCallback(() => {
    setRefreshToken((value) => value + 1);
  }, []);

  const saveDivision = useCallback(async (values) => {
    const payload = normalizePayload(values);
    if (!payload.nombre) {
      throw new Error('El nombre de la división es requerido.');
    }
    if (payload.boh === null || !validateBoh(payload.boh)) {
      throw new Error('El BoH debe ser un número entero.');
    }
    const hasId = Boolean(values?.id);
    const url = hasId ? `/admin/api/divisions/${values.id}` : '/admin/api/divisions';
    const method = hasId ? 'PUT' : 'POST';
    const response = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok || data?.error) {
      throw new Error(data?.error || 'No se pudo guardar la división');
    }
    return data;
  }, []);

  const deleteDivision = useCallback(async (id) => {
    const response = await fetch(`/admin/api/divisions/${id}`, { method: 'DELETE' });
    const data = await response.json();
    if (!response.ok || data?.error) {
      throw new Error(data?.error || 'No se pudo desactivar la división');
    }
    return data;
  }, []);

  return useMemo(() => ({
    items,
    loading,
    error,
    refresh,
    saveDivision,
    deleteDivision
  }), [items, loading, error, refresh, saveDivision, deleteDivision]);
};
